module.exports = __webpack_public_path__ + "static/media/holtzman.38d517ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/holtzman.jpg
// module id = 205
// module chunks = 0